import React, { useEffect, useMemo, useState } from 'react'
import Dialog from '@mui/material/Dialog'
import { Elements } from '@stripe/react-stripe-js'
import { StripeElementsOptions, loadStripe } from '@stripe/stripe-js'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { AppConstants, LeadStage } from 'AppConstants/AppConstants'
import Header from 'components/Header'
import useQueryParams from 'hooks/useQueryParams'
import { useAppDispatch, useAppSelector } from 'redux/store'
import { createNavigateWithQueryParams } from 'utils/navigateWithQueryParams'
import { CheckoutForm } from './CheckoutForm'
import styles from './Payment.module.scss'

const PaymentSignUp = () => {
  const { getAllParams, getParams, hasCampaign } = useQueryParams()
  const utm_source = getParams('utm_source')
  const navigate = useNavigate()
  const [disableBackButton, setDisableBackButton] = useState(false)

  // Signup flow state management
  const plans = useAppSelector((state) => state.signUpPersist.availablePlansSignUp)
  const purchasedPlan = useAppSelector((state) => state.signUpPersist.purchasedPlanSignUp)
  const selectedPlan = useAppSelector((state) => state.signUpPersist.selectedPlanSignUp)

  // Create reusable navigation function
  const navigateWithQueryParams = createNavigateWithQueryParams(navigate, getAllParams)

  //cardPayment
  const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLISH_KEY || ''
  const stripePromise = loadStripe(STRIPE_PUBLIC_KEY)

  const options: StripeElementsOptions = {
    clientSecret: purchasedPlan?.clientSecret,
    appearance: {
      // theme: 'stripe',
      variables: {
        colorPrimary: 'var(--color-primary)',
        colorBackground: 'var(--color-background)',
        colorText: 'var(--color-text-primary)',
        borderRadius: '8px',
      },
    },
  }

  const plan = useMemo(() => {
    if (plans) {
      const filterOnDemand = plans?.filter((p) => p.type === 'on-demand')
      return filterOnDemand
    } else {
      return null
    }
  }, [plans])

  const postLeadStage = async () => {
    await axios
      .post(
        AppConstants.API_URL + '/lead/stage/update',
        { stage: LeadStage.payment },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('userToken')}`,
            'x-platform-id': process.env.REACT_APP_PLATFORM_ID || '',
          },
        },
      )
      .then((res) => {
        return res
      })
      .catch((err) => {
        return err?.response
      })
  }

  useEffect(() => {
    postLeadStage()
  }, [])

  useEffect(() => {
    if (utm_source !== 'tiktok') return

    const planInfo = hasCampaign ? plan?.[0] : selectedPlan
    if (!planInfo) return

    //@ts-ignore
    ttq.track('InitiateCheckout', {
      contents: [
        {
          content_id: planInfo.id || 'PROD_123',
          content_type: 'product',
          content_name: planInfo.name || 'First Visit',
          quantity: 1,
        },
      ],
      value: planInfo.amount / 100,
      currency: 'USD',
    })
  }, [hasCampaign, plan, selectedPlan, utm_source])

  return (
    <div>
      <div className={styles.paymentContainer}>
        <Header
          headerText="Add Payment Details"
          showBackButton={true}
          onBack={() => {
            disableBackButton ? undefined : navigateWithQueryParams('/signup/confirmation')
          }}
        ></Header>
        <Elements stripe={stripePromise} options={options}>
          <div className={styles.paymentContainerDetails}>
            <CheckoutForm
              clientSecret={purchasedPlan?.clientSecret}
              planId={purchasedPlan?.paymentId}
              purchaseAmount={!hasCampaign ? (selectedPlan?.amount || 60) / 100 : (plan?.[0]?.amount || 60) / 100}
              disableBackButton={() => {
                setDisableBackButton(true)
              }}
              enableBackButton={() => {
                setDisableBackButton(false)
              }}
            ></CheckoutForm>
          </div>
        </Elements>
      </div>
    </div>
  )
}

export default PaymentSignUp
